import { CheckCircle, RotateCcw, X } from "lucide-react"
import { cn } from "../../utils/classnames"

interface Props {
  selectedCount: number
  totalCount: number
  onAcknowledge: () => void
  onUndoAcknowledge: () => void
  onSelectAll: () => void
  onClearSelection: () => void
  isAcknowledging: boolean
  showUndo: boolean
}

const BulkActionToolbar = ({
  selectedCount,
  totalCount,
  onAcknowledge,
  onUndoAcknowledge,
  onSelectAll,
  onClearSelection,
  isAcknowledging,
  showUndo
}: Props) => {
  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 z-50",
        "bg-neutral-900 text-white shadow-2xl",
        "transform transition-transform duration-300 ease-out",
        "translate-y-0"
      )}
    >
      <div className="max-w-5xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <span className="text-sm font-medium">{selectedCount} selected</span>
          {selectedCount < totalCount && (
            <button
              onClick={onSelectAll}
              className="text-xs text-neutral-400 hover:text-white underline transition-colors"
            >
              Select all {totalCount}
            </button>
          )}
        </div>

        <div className="flex items-center gap-3">
          {showUndo ? (
            <button
              onClick={onUndoAcknowledge}
              disabled={isAcknowledging}
              className="flex items-center gap-2 px-4 py-2 bg-white text-neutral-900 rounded-lg text-sm font-medium hover:bg-neutral-100 transition-colors disabled:opacity-50"
            >
              <RotateCcw size={14} />
              Mark as New
            </button>
          ) : (
            <button
              onClick={onAcknowledge}
              disabled={isAcknowledging}
              className="flex items-center gap-2 px-4 py-2 bg-primary-400 text-white rounded-lg text-sm font-medium hover:bg-primary-500 transition-colors disabled:opacity-50"
            >
              <CheckCircle size={14} />
              Mark as Reviewed
            </button>
          )}
          <button
            onClick={onClearSelection}
            className="p-2 text-neutral-400 hover:text-white rounded-lg transition-colors"
            aria-label="Clear selection"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default BulkActionToolbar
